export const TaxCredit = () => {
  return <></>;
};
